module.exports = __webpack_public_path__ + "img/qa.a0ec3ef6.svg";